import StoreContentPage from '../components/content/StoreContentPage';

/**
 * Mirrors shop/client AboutPage.js (tenant HTML from GET /content/about + prominent “About Us” hero)
 * and maison/client AboutPage.jsx (fallback: Our Story band + prose + values when API/off).
 */
const ABOUT_TITLE = (
  <>
    About <span style={{ fontStyle: 'italic' }}>Us</span>
  </>
);

const VALUE_CARDS = [
  { title: 'Quality First', desc: 'We select only the finest materials and craftsmanship.' },
  { title: 'Timeless Design', desc: 'Pieces that transcend trends and seasons.' },
  { title: 'Responsibility', desc: 'Committed to sustainable and ethical fashion.' },
];

function AboutFallback() {
  return (
    <>
      <h1
        className="font-display text-balance"
        style={{
          textAlign: 'center',
          margin: '0 0 3rem',
          fontSize: 'clamp(2rem,4vw,3rem)',
          fontWeight: 300,
        }}
      >
        Our Story
      </h1>
      <div
        style={{
          aspectRatio: '16 / 9',
          marginBottom: '3rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, hsl(36, 45%, 94%) 0%, hsl(35, 22%, 88%) 100%)',
          border: '1px solid hsl(35,18%,84%)',
        }}
      >
        <span
          className="font-display"
          style={{
            fontSize: 'clamp(2rem, 4vw + 1rem, 3rem)',
            fontWeight: 300,
            color: 'hsla(30, 10%, 12%, 0.28)',
            letterSpacing: '0.06em',
          }}
        >
          MODA MAI
        </span>
      </div>
      <div style={{ color: 'hsl(30, 8%, 34%)', lineHeight: 1.75, fontSize: '1rem', maxWidth: '48rem', margin: '0 auto' }}>
        <p style={{ margin: '0 0 1rem' }}>
          Founded with a passion for curating the finest fashion from around the world, Moda MAI brings together a
          carefully selected collection of designer brands and emerging labels under one roof.
        </p>
        <p style={{ margin: '0 0 1rem' }}>
          Our mission is simple: to help you discover pieces that make you feel confident and beautiful, without
          compromising on quality or craftsmanship. Every item in our collection has been hand-picked by our team of
          stylists and buyers.
        </p>
        <p style={{ margin: '0 0 1.5rem' }}>
          From everyday essentials to statement pieces, we believe in building wardrobes that last. We champion
          sustainable practices, supporting brands that share our commitment to responsible fashion.
        </p>
        <h2
          className="font-display"
          style={{
            margin: '2rem 0 1rem',
            fontSize: '1.75rem',
            fontWeight: 300,
            color: 'hsl(30,12%,14%)',
          }}
        >
          Our Values
        </h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '1.5rem',
            marginTop: '1rem',
          }}
          className="about-values-grid"
        >
          <style>{`@media(min-width:768px){.about-values-grid{grid-template-columns:repeat(3,1fr)!important}}`}</style>
          {VALUE_CARDS.map(({ title, desc }) => (
            <div
              key={title}
              style={{
                textAlign: 'center',
                padding: '1.5rem',
                border: '1px solid hsl(35,18%,84%)',
                background: 'hsla(40,30%,98%,0.65)',
              }}
            >
              <h3 className="font-display" style={{ margin: '0 0 0.5rem', fontSize: '1.125rem', fontWeight: 300 }}>
                {title}
              </h3>
              <p style={{ margin: 0, fontSize: '0.8125rem', opacity: 0.78, lineHeight: 1.6 }}>{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default function About() {
  return (
    <StoreContentPage
      contentKey="about"
      title={ABOUT_TITLE}
      maxWidth="48rem"
      containerPadding="clamp(3.5rem,10vw,6rem) 1.5rem clamp(4rem,12vw,7rem)"
      titleStyle={{
        fontSize: 'clamp(3rem,5vw,4.5rem)',
        fontWeight: 300,
        marginBottom: '2rem',
        color: 'inherit',
      }}
      fallback={<AboutFallback />}
    />
  );
}
